import BaseService from '../base-service.js';

class ScreenshotService extends BaseService {
  constructor() {
    super('screenshot_service/');
  }

  async generateScreenshot({ url, authToken, sectionsToHide = [] }) {
    if (!url) {
      throw new Error('URL is required');
    }

    if (!authToken) {
      throw new Error('Authentication token is required');
    }

    try {
      // Use BaseService's client (axios instance with interceptors)
      const response = await this.client.post(
        `${this.baseURL}generate`,
        {
          url: url,
          authToken: authToken,
          sectionsToHide: sectionsToHide,
        },
        {
          responseType: 'blob', // Important: Tell axios to expect binary data
        }
      );

      // Validate blob
      if (!response.data || response.data.size < 1000) {
        throw new Error('Screenshot appears to be empty or corrupted');
      }

      return response.data; // Return blob directly
    } catch (error) {
      // Handle axios errors
      if (error.response) {
        // Server returned error response
        const errorBlob = error.response.data;
        
        // Try to parse error message from blob (if it's JSON)
        if (errorBlob instanceof Blob && errorBlob.type === 'application/json') {
          const errorText = await errorBlob.text();
          const errorData = JSON.parse(errorText);
          throw new Error(errorData.error || 'Screenshot generation failed');
        }
        
        throw new Error('Screenshot generation failed');
      }
      
      // Network error or other issue
      throw this.handleError(error);
    }
  }
}

export default new ScreenshotService();